/**
 * @file Toggles classes that change fonts for accessibility.
 */
(function($, Drupal) {
  Drupal.behaviors.boemFontToggle = {
    attach: function(context, settings) {

      // Accessibility: Toggle OpenDyslexic
      $('#opendyslexic-toggle', context).once('boem-opendyslexic-toggle').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('open-dyslexic');
      });

      // Accessibility: Increase Font
      $('#font-size-toggle', context).once('boem-font-size-toggle').click(function(e) {
        e.preventDefault();
        $('.l-page__main').toggleClass('large-font');
      });
    }
  };
})(jQuery, Drupal);
